import Input from '../../input';
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Flex } from 'rebass';

export function InputControl({ settings: { type = 'input', ...settings }, ...props }) {
  const InputElement = useMemo(() => {
    switch (type) {
      case 'password':
        return Input.Password;
      case 'group':
        return Input.Group;
      case 'textarea':
        return Input.TextArea;
      default:
        return Input;
    }
  }, [type]);
  return (
    <Flex width={1} flexDirection="column">
      {React.createElement(InputElement, { ...settings, ...props })}
    </Flex>
  );
}

InputControl.propTypes = {
  name: PropTypes.string,
  value: PropTypes.any,
  placeholder: PropTypes.string,
  settings: PropTypes.object,
  hasError: PropTypes.bool,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
};
